import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-navy-900 text-slate-300 selection:bg-gold-400/30 selection:text-white" data-id="element-185">
      <HeroSection data-id="element-186" />
      <OpeningHook data-id="element-187" />
      <ProblemSection data-id="element-188" />
      <FailedSolutions data-id="element-189" />
      <MechanismSection data-id="element-190" />
      <WhatYouGet data-id="element-191" />
      <WhoIsFor data-id="element-192" />
      <HowItWorks data-id="element-193" />
      <ProofSection data-id="element-194" />
      <FAQSection data-id="element-195" />
      <OfferSection data-id="element-196" />
      <Footer data-id="element-197" />
    </main>;
}